import React from "react";
import { Icon } from "@iconify/react";

import Loader from "../../shared/components/loader";

import { socialMediasIcons } from "../../shared/utils/socialMediasIcons";
import usePageFetcher from "../../repository/usePageFetcher";

import "./style.css";

const SocialMedias = () => {
  const { isLoading, data } = usePageFetcher("about/");

  return (
    <div className="social_medias_wrapper">
      {isLoading ? (
        <Loader />
      ) : (
        <div className="content_wrapper social_media_container">
          {socialMediasIcons.map(({ id, icon, name }) => {
            return (
              <a
                href={data[0][name]}
                rel="noreferrer"
                target="_blank"
                className="social_media"
                key={id}
              >
                <Icon
                  className="social_media_icon"
                  width={"28px"}
                  icon={icon}
                />
              </a>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default SocialMedias;
